import { useContext, useEffect, useMemo } from "react";
import { QREditorContext } from "@/contexts/QREditorContext";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { UseAppsDataResult, AppsTemplateTranslations } from "../types";

export const useAppsData = (props: QRProps<"apps">): UseAppsDataResult => {
  const qrEditorContextData = useContext(QREditorContext) as QREditorContextProps<"apps"> | null;

  const translations = props.previewTranslations?.["apps"] as AppsTemplateTranslations;
  const isInitialPreview = props?.initPreview ?? false;
  const data = props?.data || qrEditorContextData?.qrData?.data;

  useEffect(() => {
    if (!isInitialPreview && qrEditorContextData?.setValidationError && data) {
      const appLinksExist = data.appLinks && data.appLinks.length > 0;
      qrEditorContextData.setValidationError(!appLinksExist);
    }
  }, [data, isInitialPreview, qrEditorContextData]);

  const { themeColor, appLinks, appsCompany, appsDescription, appsName, appsWebsite, logoUrl } =
    useMemo(() => {
      if (!data) {
        return {
          themeColor: undefined,
          appLinks: [],
          appsCompany: "",
          appsDescription: "",
          appsName: "",
          appsWebsite: "",
          logoUrl: "",
        };
      }

      return {
        themeColor: data.themeColor,
        appLinks: data.appLinks,
        appsCompany: data.appsCompany,
        appsDescription: data.appsDescription,
        appsName: data.appsName,
        appsWebsite: data.appsWebsite,
        logoUrl: data.logoUrl,
      };
    }, [data]);

  return {
    translations,
    isInitialPreview,
    data,
    themeColor,
    appLinks,
    appsCompany,
    appsDescription,
    appsName,
    appsWebsite,
    logoUrl,
  };
};
